import React, { useEffect, useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Fab,
} from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { fetchMessages } from '../../actions';
import { Content } from '../layout';
import { pageLimit as limit } from '../../config/keys';
import Pagination from '../common/Pagination';
import { targets } from './types';
import { fabStyle } from '../common/style';

const MessageList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector((state) => state.message.messages);

  useEffect(() => {
    dispatch(fetchMessages(page, limit));
  }, [dispatch, page]);

  const navigateToMessageDetail = (id) => {
    navigate(`/messages/${id}/update`, { state: { id } });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderMessages = () =>
    rows.map((message) => (
      <TableRow
        key={message.id}
        onClick={() => navigateToMessageDetail(message.id)}
        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
      >
        <TableCell>
          {
            targets.find(
              (target) => String(target.id) === String(message.target)
            ).name
          }
        </TableCell>
        <TableCell>{message.isUrgent === true ? '긴급' : '일반'}</TableCell>
        <TableCell>{message.MessageMacro?.subject}</TableCell>
        <TableCell>{new Date(message.createdAt).toLocaleString()}</TableCell>
      </TableRow>
    ));

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            메시지
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="message-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>구분</TableCell>
                  <TableCell>긴급</TableCell>
                  <TableCell>제목</TableCell>
                  <TableCell>등록일시</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderMessages()}</TableBody>
            </Table>
          </TableContainer>
          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
      <Fab
        sx={fabStyle}
        aria-label="add"
        color="primary"
        component={Link}
        to="/messages/new"
      >
        <AddIcon />
      </Fab>
    </Content>
  );
};

export default MessageList;
